import {useFetcher} from '@remix-run/react';
import {useEffect, useMemo} from 'react';
import {getMetaObjectID, findValueFromFields} from '~/utils';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import removeMarkdown from 'markdown-to-text';
import _ from 'lodash';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export const GeneratePdf = ({
  metaobjectIds,
  images,
  product,
  items,
  properties,
}: {
  metaobjectIds: any;
  images: any;
  product: any;
  items: any;
  properties: any;
}) => {
  const fetcher = useFetcher();
  const metaobjects = useMemo(() => {
    return _.get(fetcher.data, 'metaobjects');
  }, [fetcher.data]);

  let ids = '';
  _.map(metaobjectIds, (id, idx) => {
    const comma = idx === 0 ? '' : ',';
    ids += `${comma}${getMetaObjectID(id)}`;
  });

  useEffect(() => {
    if (fetcher.data || fetcher.state === 'loading') return;
    fetcher.load(`/api/metaobjects/search?ids=${ids}`);
  }, [fetcher]);

  const handleClick = async () => {
    let date = new Date();
    let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
    let today = date.toLocaleDateString('en-US', options);
    const {descriptionHtml, productdescription = ''} = product;
    function parseJSON(str: string | undefined) {
      if (str) {
        try {
          return JSON.parse(str);
        } catch (error) {
          return {};
        }
      }
      return {};
    }
    const description = parseJSON(_.get(productdescription, '[0].value'));
    let array: any = [];
    let arrayb: any = [];
    _.map(items, (bom, index: number) => {
      const ranking = _.get(bom, 'ranking');
      if (ranking === 'Key') {
        const name = _.get(bom, 'name');
        const item = _.get(bom, 'item');
        const properties = _.find(
          metaobjects,
          (metaobject) => _.get(metaobject, 'id') === _.get(item, 'id'),
        );
        let propUse = findValueFromFields(properties, 'prop_use');
        if (propUse) {
          propUse = _.get(JSON.parse(propUse), 'data');
          array.push(propUse);
          arrayb.push(name);
        }
      }
    });

    async function getBase64ImageFromURL(url: any) {
      const response = await fetch(url);
      const blob = await response.blob();
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }
    const imageUrl = images[0].previewImage.url;
    const headerUrl =
      'https://res.cloudinary.com/oves/image/upload/v1631178325/logos/Omnivoltaic-Web_Logo_H_uc7umj.png';
    const base64Image = await getBase64ImageFromURL(imageUrl);
    const headerImage = await getBase64ImageFromURL(headerUrl);

    var value = [];
    value.push([
      {text: 'Property', style: 'tableHeader'},
      {
        text: 'Definition',
        colSpan: 2,
        style: 'tableHeader',
        alignment: 'center',
      },
      {},
      {text: 'Value', style: 'tableHeader'},
    ]);
    _.map(properties, (item, index) => {
      let ranking = _.get(item, 'ranking');
      if (ranking === 'Key') {
        value.push([
          {text: _.get(item, 'name')},
          {
            text: _.get(item, 'propertyBase.name'),
            colSpan: 2,
            alignment: 'center',
          },
          {},
          {text: _.get(item, 'propertyValue')},
        ]);
      }
    });
    for (let i = 0; i < arrayb.length; i++) {
      // @ts-ignore
      value.push([
        {
          text: arrayb[i],
          fillColor: 'grey',
          style: 'tableHeader',
          colSpan: 4,
          alignment: 'center',
        },
        {},
        {},
        {},
      ]);
      value.push([
        {text: 'Property', style: 'tableHeader'},
        {
          text: 'Definition',
          colSpan: 2,
          style: 'tableHeader',
          alignment: 'center',
        },
        {},
        {text: 'Value', style: 'tableHeader'},
      ]);
      _.map(array[i], (item, index) => {
        let ranking = _.get(item, 'ranking');
        if (ranking === 'Key') {
          value.push([
            {text: _.get(item, 'name')},
            {
              text: _.get(item, 'propertyBase.name'),
              colSpan: 2,
              alignment: 'center',
            },
            {},
            {text: _.get(item, 'propertyValue')},
          ]);
        }
      });
    }
    const regex = /\\*\*Product Model\*\*:\s*([A-Z0-9_-]+)/i;
    let match = description.data.match(regex);
    if (match === null) {
      const regex = /\\*\*Product Model:\*\*\s*([A-Z0-9_-]+)/i;
      match = description.data.match(regex);
    }
    let text = '';
    if (match) {
      text = match[1];
      const modData = description.data.replace(text, '');
      description.data = modData;
    }
    let description_text = removeMarkdown(description.data);
    description_text = description_text.concat(' ', text);
    let docDefinition = {
      content: [
        {
          style: 'tableExample',
          table: {
            widths: [125, 125, 125, 125],
            body: [
              [
                {image: headerImage, height: 40, width: 125},
                {
                  text: 'Specifications',
                  style: 'tableHeader',
                  alignment: 'center',
                  colSpan: 3,
                },
                {},
                {},
              ],
              [
                {
                  text: 'Price (US$ FOB China )',
                  fillColor: 'grey',
                  style: 'tableHeader',
                },
                {text: 'Markets', fillColor: 'grey', style: 'tableHeader'},
                {text: 'Product Name', fillColor: 'grey', style: 'tableHeader'},
                {text: 'Issue', fillColor: 'grey', style: 'tableHeader'},
              ],
              [
                '',
                {
                  text: 'Asia / Africa / Oceania / Americas',
                  style: 'tableHeader',
                },
                {text: product.title, style: 'tableHeader'},
                {text: today, style: 'tableHeader'},
              ],
              [
                {
                  colSpan: 2,
                  rowSpan: 2,
                  image: base64Image,
                  width: 200,
                  height: 200,
                  alignment: 'center',
                },
                {},
                {text: 'Features', style: 'tableHeader', colSpan: 2},
                {},
              ],
              [{}, {}, {colSpan: 2, text: description_text}, {}],
              [
                {
                  text: 'Property',
                  fillColor: 'grey',
                  colSpan: 4,
                  alignment: 'center',
                },
                {},
                {},
                {},
              ],
              ...value,
            ],
          },
        },
      ],

      styles: {
        tableExample: {
          margin: [0, 0, 0, 0],
        },
        tableHeader: {
          bold: true,
          color: 'black',
        },
      },
    };

    // Replace any . in the product title with an underscore
    const filename = `${product.title.replace(/\./g, '_')}_specification.pdf`;

    pdfMake.createPdf(docDefinition).download(filename);
  };
  return (
    <button
      style={{
        height: '40px',
        width: '70px',
        background: 'white',
        border: '2px solid #14fcfc',
      }}
      onClick={handleClick}
    >
      PDF
    </button>
  );
};
